// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
import { DevicesBreakpointsEnumeration } from '@openbank/ziniaweb-ui-core-models';
// Utils
import { isDesktopDevice, isMobileDevice, isTabletDevice } from '@openbank/cf-ui-framework';

const customerAuthDataHasBeenLoaded = (
  informationFlags: AppInformationNeedEnumeration[]
): boolean =>
  informationFlags.includes(AppInformationNeedEnumeration.AUTHORIZATION_DATA) &&
  !informationFlags.includes(AppInformationNeedEnumeration.CHECKOUT_DATA);

const getClientDevice = (): string => {
  switch (true) {
    case isMobileDevice():
      return DevicesBreakpointsEnumeration.MOBILE;
    case isTabletDevice():
      return DevicesBreakpointsEnumeration.TABLET;
    case isDesktopDevice():
    default:
      return DevicesBreakpointsEnumeration.DESKTOP;
  }
};

export { customerAuthDataHasBeenLoaded, getClientDevice };
